import React from "react";
import { NavLink } from "react-router-dom";
import { BreadcrumbPropTypes } from "./propTypes";
import homeIcon from "@/assets/img/breadcrumb_home_icon.svg";
import arrowIcon from "@/assets/img/breadcrumb_arrow_icon.svg";
import "./styles.scss";

const Breadcrumb = ({ categories = [], title = "" }) => {
  if (!title || categories.length === 0) return null;

  const jsonLd = generateBreadcrumbJSONLD(categories, title);

  return (
    <nav aria-label="Breadcrumb" className="breadcrumb-nav">
      <ul>
        <li>
          <img alt="home-icon" className="w-4 h-4" src={homeIcon} />
          <NavLink to="/" preventScrollReset>
            Home
          </NavLink>
          <img alt="arrow-icon" className="w-4 h-4" src={arrowIcon} />
        </li>
        <li>
          <NavLink to="/insights" preventScrollReset>
            Blog
          </NavLink>
          <img alt="arrow-icon" className="w-4 h-4" src={arrowIcon} />
        </li>
        <li>
          {categories.map((category, index) => (
            <span key={category.id}>
              <NavLink to={`/insights/${category.slug}`} preventScrollReset>
                {category.name}
              </NavLink>
              {index < categories.length - 1 && ", "}
            </span>
          ))}
          <img alt="arrow-icon" className="w-4 h-4" src={arrowIcon} />
        </li>
        <li>{title}</li>
      </ul>
      {/* JSON-LD para SEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </nav>
  );
};

const generateBreadcrumbJSONLD = (categories, title) => {
  const itemList = [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: `${window?.location?.origin}/`,
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Blog",
      item: `${window?.location?.origin}/insights`,
    },
    ...categories.map((cat, index) => ({
      "@type": "ListItem",
      position: 3 + index,
      name: cat.name,
      item: `${window?.location?.origin}/insights/${cat.slug}`,
    })),
    {
      "@type": "ListItem",
      position: 3 + categories.length,
      name: title,
      item: window?.location?.href,
    },
  ];

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: itemList,
  };
};

Breadcrumb.propTypes = BreadcrumbPropTypes;

export default Breadcrumb;
